import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import '../scss/about-us.style.scss';
import { getAboutUsStatistics, documentIcons } from '../constant/about-us-sections.constant';
import { aboutUsHeroImage, aboutUsHistoryImage, aboutUsSharePageImage, aboutUsVisionImage, coins, rightArrowIcon } from './images/aboutUsImages';
import { socialIcons } from '../constant/social-icon.constant';
import { useNavigate } from 'react-router-dom';
import { LOCALES } from '../../common/constants';
// @ts-ignore
const imageUrl = import.meta.env.VITE_API_IMAGE_URL || '';

const AboutUsComponent: React.FC = () => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const language = localStorage.getItem("i18nextLng");
    const handleCreateAccount = () => {
        navigate(
            language === LOCALES.EN_US
                ? `/emailregister?lang=${LOCALES.EN_US}`
                : `/e-postregister?lang=${LOCALES.SV_SE}`
        );
    };
    const fTax = `${imageUrl}/F-skattInvozioLvSia.pdf`;
    const aboutUsStatistics = getAboutUsStatistics(t);
    const insuranceLetter = 'https://www.api.invozio.com/img/F%C3%B6rs%C3%A4kringsbrev.pdf?_gl=1*n4wxuh*_gcl_au*MTI5NjQ1NTIwMS4xNzU0MDMxMzcw*_ga*MTUzODI3NjcxNS4xNzU0MDMxMzcx*_ga_DJKEC77RNR*czE3NTQwMzEzNzAkbzEkZzEkdDE3NTQwMzE5MTEkajU3JGwwJGgw'
    const aggrement = 'https://invozioprod.blob.core.windows.net/files/tallypro-ab-samarbetsavtal-invozio-lv-sia.pdf?sp=r&st=2025-06-12T10:45:16Z&se=2050-06-12T18:45:16Z&spr=https&sv=2024-11-04&sr=b&sig=P23nPjL6oI4wFKwzfAFr9jazqHKz7brkGsVFPnncB0U%3D'
    const bankCertificate = 'https://invozioprod.blob.core.windows.net/files/revolut-bank-certificate.pdf?sp=r&st=2025-05-14T10:03:02Z&se=2050-05-14T18:03:02Z&spr=https&sv=2024-11-04&sr=b&sig=UQA7RyvkNJV17ee9O2oupRpcFuoTmpdNyATQGHZUq8g%3D'
    return (
        <div className="about-us-page px-0">
            {/* Partner Section */}
            <section className="partner-section px-0">
                <Container>
                    <div className="partner-row px-0">
                        <div className="partner-left">
                            <h2 className="partner-title">
                                {t('Invozio Your Partner in Self-Employment!')}
                            </h2>
                        </div>
                        <div className="partner-right">
                            <div className="partner-description">
                                <p>
                                    {t('ABOUT_US_DESCRIPTION')}
                                </p>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Hero Image */}
            <section className="hero-image-section px-0">
                <Container>
                    <img
                        src={aboutUsHeroImage}
                        alt="Invozio Platform"
                        className="hero-image"
                    />
                </Container>
            </section>

            {/* Separation Line Above Security Section */}
            <div className="separation-line"></div>

            {/* Security Section */}
            <section className="security-section px-0">
                <Container>
                    <div className="security-row px-0">
                        <div className="security-left">
                            <h2 className="security-title">
                                {t('Your Security, Our Priority')}
                            </h2>
                        </div>
                        <div className="security-right">
                            <div className="security-description">
                                <p>
                                    {t('We value our customers and continuously strive to provide a secure and reliable platform. We understand the importance of trust and actively work on cybersecurity to protect your information, including encrypting all data exchanged between our devices. All freelancers\' funds are managed in a client account at Revolut, approved by the Swedish Financial Supervisory Authority, thanks to our partnership with PS Finnans Group.We also have a comprehensive insurance policy with Trygg Hansa, tailored for personnel leasing.')}
                                </p>
                                <p>
                                    {t('Our goal is for you to feel secure and confident in managing your own business. We are transparent in our operations and support you with the help and assistance you need.')}
                                </p>
                            </div>

                            {/* Statistics within Security Section */}
                            <div className="security-stats">
                                <div className="stats-row">
                                    {aboutUsStatistics.map((stat, index) => (
                                        <div key={index} className="stat-item">
                                            <div className="stat-number">{stat.numberKey}</div>
                                            <div className="stat-label">{t(stat.labelKey)}</div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                    </div>
                </Container>
            </section>

            {/* Separation Line Below Security Section */}
            <div className="separation-line"></div>
            <>
                <Container className="company-info-section py-5">
                    <Row>
                        <Col className='px-0' xs={12} md={6} >
                            <h2 className="company-info-title">
                                {t('Company Information')}
                            </h2>
                        </Col>
                        <Col className='px-0' xs={12} md={6}>
                            <div className="company-info-right px-0">
                                {/* F-Tax Document */}
                                <div className="document-card">
                                    <div className="document-info">
                                        <div className="document-icon">
                                            <img src={coins} alt="Document" />
                                        </div>
                                        <div className="document-title">
                                            {t('F-Tax')}
                                        </div>
                                    </div>
                                    <button className="download-btn" onClick={() => window.open(fTax, '_blank')}>
                                        <span>{t('Download PDF')}</span>
                                        <img src={documentIcons.download} alt="Download" />
                                    </button>
                                </div>

                               

                                {/* Insurance Letter */}
                                <div className="document-card">
                                    <div className="document-info">
                                        <div className="document-icon">
                                            <img src={coins} alt="Document" />
                                        </div>
                                        <div className="document-title">
                                            {t('Insurance Letter')}
                                        </div>
                                    </div>
                                    <button className="download-btn" onClick={() => window.open(insuranceLetter, '_blank')}>
                                        <span>{t('Download PDF')}</span>
                                        <img src={documentIcons.download} alt="Download" />
                                    </button>
                                </div>
                                {/* Bank certificate */}
                                <div className="document-card">
                                    <div className="document-info">
                                        <div className="document-icon">
                                            <img src={coins} alt="Document" />
                                        </div>
                                        <div className="document-title">
                                            {t('Bank Certificate')}
                                        </div>
                                    </div>
                                    <button className="download-btn" onClick={() => window.open(bankCertificate, '_blank')}>
                                        <span>{t('Download PDF')}</span>
                                        <img src={documentIcons.download} alt="Download" />
                                    </button>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </>

            <Container className="history-vision-section ">
                {/* History - Image Left, Content Right */}
                <Row className="px-0">
                    <Col className="px-0" xs={12} md={6}>
                        <div className="history-image">
                            <img src={aboutUsHistoryImage} className='img-fluid' alt="Our History" />
                        </div>
                    </Col>
                    <Col xs={11} md={5} className="px-0 ml-0 ml-sm-auto">
                        <h2 className="Heading_h2 text-start">{t('Our History')}</h2>
                        <div className="history-description">
                            <p>
                                {t('Invozio was founded in 2022 with the ambition to transform the way freelancers conduct business and invoice without owning a company. We identified a need for a flexible and cost-effective solution, marking the beginning of our journey. Our staffing agency has been operational since 2015, and our team has been working with consultants since 2008.')}
                            </p>
                            <p>
                                {t('We initially focused on hiring consultants with a niche in bringing labor from countries like Estonia and Latvia to Sweden, Norway, and Finland. We built the first version of our platform for our own consultants and opened it to the public on April 1, 2023.')}
                            </p>
                        </div>
                    </Col>
                </Row>

                {/* Vision - Content Left, Image Right */}
                <Row className=" px-0 my-5">
                    <Col xs={12} md={6} className="px-0 mr-auto">
                        <div className="vision-left">
                            <h2 className="vision-title">{t('Our Vision')}</h2>
                            <div className="vision-description">
                                <p>
                                    {t('We aim to be the leading platform in self-employment and invoicing without a company. We are dedicated to revolutionizing freelance work and creating a working environment that is flexible, secure, and rewarding.')}
                                </p>
                                <p>
                                    {t('We continue to develop our services to meet the unique needs of freelancers globally. By being responsive to user feedback and continuously improving our platform, we aim to simplify the invoicing process and support freelancers on their path to success.')}
                                </p>
                                <p>
                                    {t('We are committed to being a reliable partner by offering high security and trust, collaborating with trusted insurance companies and partners to provide additional protection and benefits to our users.')}
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={12} md={6} className="px-0 ml-auto">
                        <img src={aboutUsVisionImage} style={{
                            borderRadius: '20px',
                        }} className='img-fluid' alt="Our Vision" />
                    </Col>
                </Row>
            </Container>


            {/* Share Page Section */}
            <section className="share-page-section">
                <Container>
                    <Row className="align-items-center px-0">
                        <Col xs={12} md={6} className='px-0'>
                            <div className="share-page-content">
                                <h2 className="share-page-title">{t('Share Our Page')}</h2>
                                <p className="share-page-description">
                                    {t('Share Invozio with your friends on socials media and help us grow!')}
                                </p>
                                <div className="social-icons">
                                    {socialIcons.map((icon, index) => (
                                        <a
                                            key={index}
                                            href={icon.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="social-icon"
                                        >
                                            <img src={icon.icon} alt={icon.ariaLabel} />
                                        </a>
                                    ))}
                                </div>
                                <p className="share-page-subdescription">
                                    {t('With just a small fee, you can maximize your financial gain and focus on growing your freelance business.')}
                                </p>
                                <button className="create-account-btn" onClick={handleCreateAccount}>
                                    <span>{t('Create Free Account')}</span>
                                    <img src={rightArrowIcon} alt="Right Arrow" />
                                </button>
                            </div>
                        </Col>
                        <Col xs={12} md={6}>
                            <div className="share-page-image">
                                <img src={aboutUsSharePageImage} alt="Share Invozio" />
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default AboutUsComponent;
